import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { DescriptionText } from 'components/common/infoText/infoText';

export const DescriptionDecorator = (Component) => {
  const DecoratedComponent = (props) => {
    const { description, ...rest } = props;
    if (!description) {
      return <Component {...props} />;
    }
    return (
      <Fragment>
        <Component {...rest} />
        <DescriptionText className="input-description">{description}</DescriptionText>
      </Fragment>
    );
  };
  DecoratedComponent.propTypes = {
    description: PropTypes.string
  };
  DecoratedComponent.defaultProps = {
    description: undefined
  };
  return DecoratedComponent;
};

export const DescriptionDecoratorTop = (Component) => {
  const DecoratedComponent = (props) => {
    const { description, ...rest } = props;
    if (!description) {
      return <Component {...props} />;
    }
    return (
      <Fragment>
        <DescriptionText className="input-description">{description}</DescriptionText>
        <Component {...rest} />
      </Fragment>
    );
  };
  DecoratedComponent.propTypes = {
    description: PropTypes.string
  };
  DecoratedComponent.defaultProps = {
    description: undefined
  };
  return DecoratedComponent;
};

export default DescriptionDecorator;
